export default [
  {
    path: '/cliente/dispensa-aviso-certificado-digital/autorizacao',
    name: 'dispensa-aviso-certificado-digital-autorizacao',
    component: () => import('@/app-modulo/comuns/leading-pages/externo/desabilatar-aviso-certificado-digital/AutorizacaoEmpresa.vue'),
    meta: {
      requiredAuth: false,
      layout: 'full',
    },
  },
  {
    name: 'dispensa-aviso-certificado-digital',
    path: '/cliente/dispensa-aviso-certificado-digital',
    component: () => import('@/app-modulo/comuns/leading-pages/externo/desabilatar-aviso-certificado-digital/DispensaAvisoCertificadoDigial.vue'),
    meta: {
      resource: 'dispensaavisodertificadodigital',
      action: 'read',
      requiredAuth: false,
      layout: 'full',
    },
  },
]
